import React from "react";

export default function AWS_Polly() {
  return (
    <div>
      <h1>What is AWS Polly</h1>
      <p>
        Route: <code>/aws/polly</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
